module.exports = __webpack_public_path__ + "0a2f5a3073704bb0dfa72d234dd8dbbd.pdf";